import { jsx } from '@emotion/react';
import { Animation } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { baseReset } from '../../../../utils/style-mixins/reset';
const Styles = labelStyles('InAppSidebarError', {
    toggle: Object.assign(Object.assign({}, baseReset), { font: `var(--zds-small-print-1)`, color: 'var(--zds-status-error, #F65258)', cursor: 'pointer', padding: '3px 0', borderBottom: `1px solid transparent`, transition: Animation.transitionValue, '&:hover, &:focus': {
            borderBottomColor: 'var(--zds-status-error, #F65258)',
        } }),
    message: Object.assign(Object.assign({}, baseReset), { color: 'var(--zds-status-error, #F65258)', marginTop: 10, padding: 10, border: `1px solid var(--zds-background-strongest, #ECE9DF)`, borderRadius: 5, font: '14px/18px monospace' }),
});
const InAppSidebarError = (props) => {
    return (jsx("details", { "data-zds": true },
        jsx("summary", { css: Styles.toggle, "data-zds": true }, "Oh no, something went wrong!"),
        jsx("pre", { css: Styles.message, "data-zds": true }, props.children)));
};
export default InAppSidebarError;
//# sourceMappingURL=InAppSidebarError.js.map
// @zapier/universal-layout@12.2.9 (038caa1ab)
